module.exports = __webpack_public_path__ + "img/Suv_Front_Side_Right_Transparent.8089765b.svg";